module.exports = __webpack_public_path__ + "img/cbs.d57c79ec.png";